export const CyItem = {
  SearchResultPreview: "SearchResultPreview",
  UploadSourceFileButton: "UploadSourceFileButton",
  SongSourceCard: "SongSourceCard",
  DerivedImagesCard: "DerivedImagesCard",
  ChordsheetCard: "ChordsheetCard",
  DeleteSourceButton: "DeleteSourceButton",
  SourceFileLink: "SourceFileLink",
  DeleteDerivedImageButton: "DeleteDerivedImageButton",
  RotateLeftButton: "RotateLeftButton",
  RotateRightButton: "RotateRightButton",
  BuildDerivedImagesForSourceButton: "BuildDerivedImagesForSourceButton",
  DragHandle: "DragHandle",
  ChangeOrderLoadingSpinner: "ChangeOrderLoadingSpinner",
  CropButton: "CropButton",
  CropModalCancelButton: "CropModalCancelButton",
  CropModalConfirmButton: "CropModalConfirmButton",
  AddSongnumberButton: "AddSongnumberButton",
  SongnumberModal: "SongnumberModal",
  SongnumberModalConfirm: "SongnumberModalConfirm",
  SongnumberDisplay: "SongnumberDisplay",
  FieldSaveStatus: "FieldSaveStatus",
} as const;
